export default class UnavailableAccommodation {
    constructor(data) {
        // Field is not returned by API, adding it here just to be able to use the AccommodationDetails component for UnavaiilableAccommodation
        Object.defineProperty(this, "adults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        // Field is not returned by API, adding it here just to be able to use the AccommodationDetails component for UnavaiilableAccommodation
        Object.defineProperty(this, "amenities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "images", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Field is not returned by API, adding it here just to be able to use the AccommodationDetails component for UnavaiilableAccommodation
        Object.defineProperty(this, "isPrivate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Field is not returned by API, adding it here just to be able to use the AccommodationDetails component for UnavaiilableAccommodation
        Object.defineProperty(this, "kids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "maxGuests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Field is not returned by API, adding it here just to be able to use the AccommodationDetails component for UnavaiilableAccommodation
        Object.defineProperty(this, "numBeds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.description = data.room_type_desc;
        this.id = data.room_type_id.toString();
        this.maxGuests = parseInt(data.max_guests);
        this.name = data.room_type_name;
        this.title = data.room_type_title;
        this.images = data.photos_gallery.map((src, index) => ({
            alt: data.photos_gallery_alt[index],
            src: src,
            thumb: src,
        }));
    }
}
